import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React, { useMemo } from 'react'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const TypesFilter = (props) => {
  const { translate } = useTranslation()
  const { types, typesFilters, setTypesFilters, useInner = false } = props
  const selectorData = useMemo(() => types.map((item) => ({
    name: translate(`filters.payments.${item}`),
    id: item
  })), [types, translate])

  const checkboxSelectorProps = {
    setDataFilters: setTypesFilters,
    direction: 'bottom',
    dataFilters: typesFilters,
    typeFilter: 'statuses',
    data: selectorData,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title={translate('filters.payment.type')}
        options={selectorData}
        selectedIds={typesFilters}
        onClearFilters={() => setTypesFilters([])}
      />
    </CheckboxSelector>
  )
}
export default TypesFilter
